export default __webpack_public_path__ + "static/media/tipa_did_icon.0710d81a.png";